export const routes = {
  ADMIN_LOGIN: {
    METHOD: 'POST',
    URL: '/login',
  },
  USER_LISTING: {
    METHOD: 'POST',
    URL: '/customer',
  },
  ADD_MEMBER: {
    METHOD: 'POST',
    URL: '/customer/create',
  },
  UPDATE_MEMBER: {
    METHOD: 'POST',
    URL: '/customer/update',
  },
  DELETE_MEMBER: {
    METHOD: 'POST',
    URL: '/customer/delete',
  },
  PAYMENT_LISTING: {
    METHOD: 'POST',
    URL: '/payment/list',
  },
  FAILED_PAYMENT_LISTING: {
    METHOD: 'POST',
    URL: '/failed-payment/list',
  },
  NUMBER_LISTING: {
    METHOD: 'POST',
    URL: '/did/list',
  },
  BUNDLE_LISTING: {
    METHOD: 'POST',
    URL: '/bundle/list',
  },
  ADD_BUNDLE: {
    METHOD: 'POST',
    URL: '/bundle/create',
  },
  UPDATE_BUNDLE: {
    METHOD: 'POST',
    URL: '/bundle/update',
  },
  DELETE_NUMBER: {
    METHOD: 'POST',
    URL: '/did/delete',
  },
  PLAN_LISTING: {
    METHOD: 'POST',
    URL: '/plan/list',
  },
  ADD_PLAN: {
    METHOD: 'POST',
    URL: '/plan/create',
  },
  PAYMENT_HISTORY: {
    METHOD: 'POST',
    URL: '/payment/history',
  },
  CALL_HISTORY: {
    METHOD: 'POST',
    URL: '/call/list',
  },
  SMS_HISTORY: {
    METHOD: 'POST',
    URL: '/sms/list',
  },
  BUNDLE_HISTORY: {
    METHOD: 'POST',
    URL: '/bundle/history',
  },
  REFUND_HISTORY: {
    METHOD: 'POST',
    URL: '/payment/refund',
  },
  RATES_CALL: {
    METHOD: 'POST',
    URL: '/call-rate',
  },
  RATES_SMS: {
    METHOD: 'POST',
    URL: '/sms-rate',
  },
  PROVIDERS: {
    METHOD: 'POST',
    URL: '/provider',
  },
  ADMIN_LOGIN_DASHBOARD: {
    METHOD: 'POST',
    URL: '/user-login',
  },
  CREATE_SETTINGS: {
    METHOD: 'POST',
    URL: '/settings/create',
  },
  UPDATE_SETTINGS: {
    METHOD: 'POST',
    URL: '/settings/update',
  },
  GET_SETTINGS: {
    METHOD: 'GET',
    URL: '/settings/get',
  },
  CREATE_PROVIDER: {
    METHOD: 'POST',
    URL: '/provider/create',
  },
  UPDATE_PROVIDER: {
    METHOD: 'POST',
    URL: '/provider/update',
  },
  DELETE_PROVIDER: {
    METHOD: 'POST',
    URL: '/provider/delete',
  },
  EXPORT: {
    METHOD: 'POST',
    URL: '/provider/export',
  },
  ALL_PROVIDER_CALL: {
    METHOD: 'GET',
    URL: '/provider/call',
  },
  ALL_PROVIDER_SMS: {
    METHOD: 'GET',
    URL: '/provider/sms',
  },
  UPLOAD_CALL_RATES: {
    METHOD: 'POST',
    URL: '/import-call-rate',
  },
  UPLOAD_SMS_RATES: {
    METHOD: 'POST',
    URL: '/import-sms-rate',
  },
  UPDATE_CALL_MARGIN: {
    METHOD: 'POST',
    URL: '/update-call-margin',
  },
  UPDATE_SMS_MARGIN: {
    METHOD: 'POST',
    URL: '/update-sms-margin',
  },
  FRANCE_LIST: {
    METHOD: 'POST',
    URL: '/available-did/list',
  },
  FRANCE_LIST_UPDATE: {
    METHOD: 'POST',
    URL: '/france-did/list',
  },
  FRANCE_CREATE: {
    METHOD: 'POST',
    URL: '/france-did/create',
  },
  FRANCE_UPDATE: {
    METHOD: 'POST',
    URL: '/france-did/update',
  },
  FRANCE_DELETE: {
    METHOD: 'POST',
    URL: '/france-did/delete',
  },
  FRANCE_CITIES: {
    METHOD: 'GET',
    URL: '/france-city',
  },
  FRANCE_DID_REQUEST: {
    METHOD: 'POST',
    URL: '/france-did-request/list',
  },
  FRANCE_DID_REQUEST_DELETE: {
    METHOD: 'POST',
    URL: '/france-did-request/delete',
  },
  FRANCE_DID_ASSIGN: {
    METHOD: 'POST',
    URL: '/france-did-request/assign',
  },
  CUSTOMER_BUNDLE_UPDATE: {
    METHOD: 'POST',
    URL: '/customer/bundle/update',
  },
  GET_BUNDLE_DETAIL: {
    METHOD: 'POST',
    URL: '/customer/bundle',
  },
  DID_UPDATE: {
    METHOD: 'POST',
    URL: '/did/update',
  },

  // action creators

  ADMIN_UPDATE_USER: {
    METHOD: 'POST',
    URL: '/admin-update-user',
  },

  ADMIN_CREATE_PLAN: {
    METHOD: 'POST',
    URL: '/admin-create-plan',
  },
  MEMBER_LISTING: {
    METHOD: 'POST',
    URL: '/admin-member-listing',
  },

  PAYMENT_REFUND: {
    METHOD: 'POST',
    URL: '/payment/refund-amount',
  },
  ADMIN_UPDATE_PLAN: {
    METHOD: 'POST',
    URL: '/admin-update-plan',
  },
  Dashboard: {
    Calls: {
      METHOD: 'POST',
      URL: '/dashboard/calls',
    },
    Payments: {
      METHOD: 'POST',
      URL: '/dashboard/payment',
    },
    Users: {
      METHOD: 'POST',
      URL: '/dashboard/users',
    },
  },

  FEATURES_LISTING: {
    METHOD: 'POST',
    URL: '/feature/listing',
  },

  UPDATE_FEATURES_LISTING: {
    METHOD: 'POST',
    URL: '/feature/update',
  },

  ADD_FEATURES_LISTING: {
    METHOD: 'POST',
    URL: '/feature/add',
  },

  PLAN_FEATURES_LISTING: {
    METHOD: 'GET',
    URL: '/feature/plan-features',
  },
  GET_ALL_DID_COUNTRIES: {
    METHOD: 'POST',
    URL: '/did-country/assign',
  },
  GET_ALL_DID_COUNTRIES_LIST: {
    METHOD: 'GET',
    URL: '/did-country-list',
  },
  ADD_COUNTRY_DID: {
    METHOD: 'POST',
    URL: '/did-country/add',
  },
  DELETE_DID_CONTRY: {
    METHOD: 'POST',
    URL: '/did-country/delete',
  },
  CHANGE_STATUS_COUNTRY: {
    METHOD: 'POST',
    URL: '/did-country/status',
  },
  LIVE_USERS_LISTING: {
    METHOD: 'POST',
    URL: '/customer/live',
  },
  LIVE_VN_NUMBER_LISTING: {
    METHOD: 'POST',
    URL: '/did/live',
  },
  UPLOAD_LIVE_USERS: {
    METHOD: 'POST',
    URL: '/customer/import',
  },
  UPLOAD_LIVE_NUMBER: {
    METHOD: 'POST',
    URL: '/did/import',
  },
  EXTERNAL_PAYMENT_LIST: {
    METHOD: 'POST',
    URL: '/external-payment/list',
  },
  BUNDLE_LISTING_SMS: {
    METHOD: 'POST',
    URL: '/bundle/sms/list',
  },
  BUNDLE_LISTING_VN: {
    METHOD: 'POST',
    URL: '/bundle/vn/list',
  },
  BUNDLE_LISTING_CALL: {
    METHOD: 'POST',
    URL: '/bundle/call/list',
  },
  BUNDLE_COMPLETE_DELETE: {
    METHOD: 'DELETE',
  },
  EDIT_KYC_DETAILS: {
    METHOD: 'POST',
    URL: '/did-request/update',
  },
  KYC_VERIFICATION: {
    METHOD: 'GET',
    URL: '/kyc_verification',
  },
  PROF_TYPE: {
    METHOD: 'GET',
    URL: '/proof_types',
  },
  ADDRESS_PRO0F_TYPE: {
    METHOD: 'GET',
    URL: '/proof_types/Address',
  },
  PROOF_TYPE_ID: {
    METHOD: 'GET',
    URL: '/proof_types',
  },
  MEDIA_UPLOAD: {
    METHOD: 'POST',
    URL: '/api/media-upload',
  },
  EXPIRED_VN_LIST: {
    METHOD: 'POST',
    URL: '/expired-did',
  },
  EXPIRED_VN_REVERT: {
    METHOD: 'POST',
    URL: '/expired-did/revert',
  },
  EXPIRED_VN_DELETE: {
    METHOD: 'POST',
    URL: '/expired-did/delete',
  },
  DID_PORTED_LISTING: {
    METHOD: 'POST',
    URL: '/porting-listing',
  },
  ADD_PORTED: {
    METHOD: 'POST',
    URL: '/create-porting',
  },
  UPDATE_PORTED: {
    METHOD: 'POST',
    URL: '/update-porting',
  },
  DELETE_PORTED: {
    METHOD: 'POST',
    URL: '/delete-porting',
  },
  VERIFY_MSIDN: {
    METHOD: 'POST',
    URL: '/check-user',
  },
  ROUTE_PREFIX: {
    METHOD: 'POST',
    URL: '/check-user',
  }
};
